// extracted by mini-css-extract-plugin
export default {"changeAccountContainerHeader":"open-claims_changeAccountContainerHeader__eyUdX","changeAccountContainerSubHeader":"open-claims_changeAccountContainerSubHeader__P9h+K"};